import { Slider } from "../_super/_slider";

const sliderName = "contentsCard"; //swiperのクラス名
const noSliderName = "noSwiper"; //非swiperのクラス名

//スライダー用関数
export const casesSlider = (sliderElement, modifierOptions) => {
	const parent = sliderElement.closest(`.${sliderName}-swiper`);
	let activeDot;
	let options = {
		slidesPerView: "auto",
		centeredSlides: true,
		navigation: {
			nextEl: parent.querySelector(
				`.${sliderName}_button.${sliderName}_button-next`
			),
			prevEl: parent.querySelector(
				`.${sliderName}_button.${sliderName}_button-prev`
			),
		},
		pagination: {
			el: parent.querySelector(`.${sliderName}_pagination`),
			clickable: true,
		},
		spaceBetween: 20,
		breakpoints: {
			737: { spaceBetween: 30 },
		},
		on: {
			afterInit: function () {
				if (parent.querySelector(".swiper-pagination-bullet-active")) {
					activeDot = parent.querySelector(".swiper-pagination-bullet-active");
					createCanvas(activeDot);
					drawCircle(activeDot);
				}
			},

			slideChangeTransitionStart: function () {
				if (activeDot) {
					activeDot.querySelector(".swiperPagination_canvas").remove();
					activeDot = parent.querySelector(".swiper-pagination-bullet-active");
					createCanvas(activeDot);
				}
			},

			slideChangeTransitionEnd: function () {
				if (activeDot) {
					drawCircle(activeDot);
				}
			},
		},
		...modifierOptions,
	};

	if (
		sliderElement.querySelectorAll(`.${sliderName}_item.swiper-slide`).length >=
		4
	) {
		//画像が4枚以上の場合
		const slider = new Slider({
			sliderElement,
			options,
		});
	} else if (
		sliderElement.querySelectorAll(`.${sliderName}_item.swiper-slide`).length >=
		2
	) {
		//画像が2枚以上の場合
		const slider = new Slider({
			sliderElement,
			options,
		});

		slider.responsiveSP();

		if (window.innerWidth > 736) {
			sliderElement.classList.add(noSliderName);
		} else {
			sliderElement.classList.remove(noSliderName);
		}

		let resizeTimer = null;

		window.addEventListener("resize", (e) => {
			//resizeTimerがあればタイマーを解除
			if (resizeTimer != null) {
				clearTimeout(resizeTimer);
			}
			resizeTimer = setTimeout(() => {
				slider.responsiveSP();
				if (window.innerWidth > 736) {
					sliderElement.classList.add(noSliderName);
				} else {
					sliderElement.classList.remove(noSliderName);
				}
			}, 500);
		});
	} else {
		//画像が1枚の場合
		removeBtn(parent);

		sliderElement.classList.add(noSliderName);
	}
};

//ボタンを削除する関数
const removeBtn = (parent) => {
	parent.querySelector(`.${sliderName}_button-prev`).remove();
	parent.querySelector(`.${sliderName}_button-next`).remove();
	parent.querySelector(`.${sliderName}_pagination`).remove();
};

//キャンバスの作成
const createCanvas = (activeDot) => {
	const width = 30;
	const height = 30;
	const canvas = document.createElement("canvas");
	canvas.classList.add("swiperPagination_canvas");
	canvas.width = width;
	canvas.height = height;
	activeDot.appendChild(canvas);
};

//プログレスバーの表示
const drawCircle = (activeDot) => {
	const width = 30;
	const height = 30;
	const MS = 5000;
	const FPS = 60 / MS;
	const START = 1.5;
	let goal = 1.5;

	const progressBar = activeDot.querySelector(".swiperPagination_canvas");
	const context = progressBar.getContext("2d");
	const gradient = context.createConicGradient(
		(Math.PI * 3) / 2,
		width / 2,
		height / 2
	);
	gradient.addColorStop(0, "#ff4402");
	gradient.addColorStop(0.16, "#fb417f");
	gradient.addColorStop(0.27, "#d921b6");
	gradient.addColorStop(0.42, "#9a0af1");
	gradient.addColorStop(0.61, "#4d27f9");
	gradient.addColorStop(0.82, "#29c57c");
	gradient.addColorStop(1, "#fbb502");
	context.strokeStyle = gradient;
	context.lineWidth = 1;

	function draw() {
		if (goal < 3.5) {
			context.clearRect(0, 0, width, height);
			requestAnimationFrame(draw);
		} else {
		}
		goal += FPS;
		context.beginPath();
		context.arc(width / 2, height / 2, 24 / 2, START * Math.PI, goal * Math.PI);
		context.stroke();
	}

	draw();
};
